var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocsArrow = function SvgDocsArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.688 1.25H7.5a3.125 3.125 0 0 1 3.125 3.125v1.563c0 .863.7 1.562 1.563 1.562h1.562a3.125 3.125 0 0 1 3.125 3.125v6.563c0 .862-.7 1.562-1.562 1.562H4.688a1.563 1.563 0 0 1-1.563-1.562V2.813c0-.864.7-1.563 1.563-1.563m5.754 8.308a.625.625 0 0 0-.884 0l-2.5 2.5a.627.627 0 0 0 .192 1.037.625.625 0 0 0 .692-.153l1.433-1.434V15a.625.625 0 1 0 1.25 0v-3.492l1.433 1.434a.627.627 0 0 0 .9.015.623.623 0 0 0-.016-.899z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.875 4.375a4.36 4.36 0 0 0-1.065-2.861 8.14 8.14 0 0 1 5.802 5.802A4.36 4.36 0 0 0 13.75 6.25h-1.562a.313.313 0 0 1-.313-.312z"
  })));
};
export default SvgDocsArrow;